import 'core-js/stable';
// add lazy-load supported
import LazyLoad from "vanilla-lazyload";
import lazyLoad from "./components/lazyLoad";

// responsive table
function _coverTable() {
    let table = document.querySelectorAll('table');
    for (let i = table.length - 1; i >= 0; i--) {
        let cover = document.createElement('div');
        cover.classList.add('cover-table');
        table[i].parentNode.insertBefore(cover, table[i]);
        cover.appendChild(table[i]);
    }
}

_coverTable();

document.addEventListener('DOMContentLoaded', function () {
    let burger = document.querySelector('.burger');
    let body = document.querySelector('body');
    let menu = document.querySelector('.header__nav-mobile ul');
    let headerMobile = document.querySelector('.header__container-mobile');

    let isMenuOpen = false;

    burger.addEventListener('click', function () {
        burger.classList.toggle('close');
        isMenuOpen = !isMenuOpen;
        if (isMenuOpen) {
            headerMobile.style.height = '100vh';
            menu.style.display = 'flex';
            body.style.overflow = 'hidden';
        } else {
            headerMobile.style.height = '0';
            menu.style.display = 'none';
            body.style.overflow = 'scroll';
        }
    });
});

